export enum InternalNotificationType {
  ORDER_PLACED_SELLER = 'ORDER_PLACED_SELLER',
  CONTACT_FORM_SUBMITTED = 'CONTACT_FORM_SUBMITTED',
  ABANDONED_CART = 'ABANDONED_CART',
  ORDER_PENDING_PAYMENT = 'ORDER_PENDING_PAYMENT',
}

export interface CustomerNotificationConfig {
  delayHours?: number;
}

export interface InternalNotificationConfig {
  id: string;
  accountId: string;
  notificationType: InternalNotificationType;
  enabled: boolean;
  recipientUserIds: string[] | null;
  recipientEmails: string[] | null;
  config: CustomerNotificationConfig | null;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpdateNotificationSettingsDTO {
  enabled?: boolean;
  recipientUserIds?: string[];
  recipientEmails?: string[];
  delayHours?: number;
}
